import React from 'react'
import { Link, useResolvedPath } from 'react-router-dom'
import { Content } from 'ui'
import { DataManagementShell } from './DataManagementShell'

const MainContent: React.FC = () => {
  const url = useResolvedPath('/admin/management')
  return (
    <>
      <Link to={`${url}/content/`.replace('//', '/')}>
        <Content.ActionButton label="Manage Content Areas / Job Fields" />
      </Link>
      <Link to={`${url}/districts/`.replace('//', '/')}>
        <Content.ActionButton label="Manage School Districts" />
      </Link>
    </>
  )
}

export const DataManagementMainView: React.FC = () => (
  <DataManagementShell heading="Data Management" main={<MainContent />} />
)
